import React from 'react';
import Flagship from '../../core/flagship';
import {empty, arraysEqual} from '../../utils/helpers';
import '../../styles/field.scss';
import {Label, Icon, Button, Segment } from 'semantic-ui-react';
import Field from './Field';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

class FlightField extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = this.getInitialState();
        this.deleteFlight = this.deleteFlight.bind(this);
        this.addFlight = this.addFlight.bind(this);

        this.nonGoogle = (!empty(this.props.nonGoogle) ? this.props.nonGoogle : false );
        this.footTraffic = (!empty(this.props.footTraffic) ? this.props.footTraffic : false );

    }

    getInitialState() {

        let initialValue = [
            {
                startDate: "",
                endDate: "",
                budget: "",
                spendGoogle: "",
                retailCPM: "",
                mgmtFee:"",
                goal: ""
            }
        ];

        if (!empty(this.props.value) && !arraysEqual(this.props.value,[""])) {
            initialValue = this.props.value;
        }

        return {
            instances: initialValue.length,
            focused: false,
            value: initialValue,
            errors: false,
            errorMessage: '',
        }
    }

    componentWillReceiveProps(nextProps) {

        if ( nextProps !== this.props ) {
            this.setState({
                value: nextProps.value,
                instances: nextProps.value.length
            });
        }
    }


    deleteFlight(e, instance) {

        let newValue = [...this.state.value];
        newValue.splice(instance,1);

        this.setState({
            value: newValue,
            instances: newValue.length
        });

        this.props.onChange(e,newValue)
    }

    addFlight() {

        let newValue =[...this.state.value];
        newValue.push({});

        this.setState({
            value: newValue,
            instances: newValue.length
        });
    }

    onChange(e, data, subField, instance) {

        let newValue = [...this.state.value];

        let valid = true;

        if (subField === "startDate" || subField === "endDate") {
            let startDate = (subField === "startDate" ? data : newValue[instance].startDate);
            let endDate = (subField === "endDate" ? data : newValue[instance].endDate);

            if (!empty(startDate) && !empty(endDate)) {
                valid = moment(endDate).isAfter(startDate);
            }
        }

        if (valid === false) {
            Flagship.notify("Your flight can't end before it starts.", "error");
        } else {
            newValue[instance][subField] = data;
            this.setState({
                value: newValue
            });
        }

        if(typeof this.props.onChange === "function") {
            this.props.onChange(e, newValue);
        }
    }

    render() {

        let self = this;

        return(
            <div className="all-flights-container">
            { Array.apply(null, {length: this.state.instances}).map(function(b, key) {

                let instance = {
                    startDate: null,
                    endDate: null,
                    budget: '',
                    spendGoogle: '',
                    retailCPM: '',
                    mgmtFee: '',
                    goal: ''
                };

                if (!empty(self.state.value[key])) {
                    instance = self.state.value[key];
                }

                if ( !empty( instance.endDate ) ) {
                    instance.endDate = moment(instance.endDate);
                } else {
                    instance.endDate = null;
                }

                if ( !empty( instance.startDate ) ) {
                    instance.startDate = moment(instance.startDate);
                } else {
                    instance.startDate = null;
                }

                let flightLabel = ( self.state.instances > 1 ? "Flight #" + (key + 1) : "Campaign");

                return (
                    <div className="single-flight-container">
                        <Segment className="single-flight no-move single-flight-heading" attached="top" inverted color="green">
                            <div className="field-container clearfix">
                                <div className="ui input single-flight-fields">
                                    <Label className="single-flight-label" color="green">{flightLabel}</Label>
                                    { self.state.instances > 1 ?
                                        <Icon
                                            className="delete-flight"
                                            name="delete"
                                            circular
                                            link
                                            inverted
                                            size="small"
                                            onClick={(e) => self.deleteFlight(e, key)}
                                        /> : null
                                    }

                                    <div className="flight-date-range">
                                        <div className="flagship-single-field field-type-date">
                                            <DatePicker
                                                selected={instance.startDate}
                                                placeholderText="Start Date"
                                                selectsStart
                                                startDate={instance.startDate}
                                                endDate={instance.endDate}
                                                maxDate={instance.endDate}
                                                minDate={moment().add(3,"days")}
                                                onChange={(value, e) => self.onChange(e, value, "startDate", key)}
                                            />
                                        </div>
                                        <span className="date-separator">&mdash;</span>
                                        <div className="flagship-single-field field-type-date">
                                            <DatePicker
                                                selected={instance.endDate}
                                                placeholderText="End Date"
                                                selectsEnd
                                                startDate={instance.startDate}
                                                endDate={instance.endDate}
                                                minDate={!empty(instance.startDate) ? instance.startDate : null}
                                                onChange={(value, e) => self.onChange(e, value, "endDate", key)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Segment>
                    <Segment attached className="single-flight no-move" key={key}>
                        <div className="field-container clearfix">
                            <div className="ui input single-flight-fields">

                                <div className="flight-goal-budget">
                                    <Field
                                        validation=""
                                        type="text"
                                        placeholder="Goal"
                                        value={!empty(instance.goal) ? instance.goal : ''}
                                        onChange={(e, value) => self.onChange(e, value, "goal", key)}
                                    />

                                    <Field
                                        validation="money"
                                        type="text"
                                        placeholder="Total Budget"
                                        value={!empty(instance.budget) ? instance.budget : ''}
                                        onChange={(e, value) => self.onChange(e, value, "budget", key)}
                                    />
                                </div>
                                {self.nonGoogle === false ?
                                    <div className="flight-spend-fee">
                                        <Field
                                            validation="money"
                                            type="text"
                                            className="spend-to-google"
                                            placeholder="Spend to Google"
                                            value={!empty(instance.spendGoogle) ? instance.spendGoogle : ''}
                                            onChange={(e, value) => self.onChange(e, value, "spendGoogle", key)}
                                        />
                                        <Field
                                            validation="money"
                                            type="text"
                                            className="mgmt-fee"
                                            placeholder="Mgmt. Fee"
                                            value={!empty(instance.mgmtFee) ? instance.mgmtFee : ''}
                                            onChange={(e, value) => self.onChange(e, value, "mgmtFee", key)}
                                        />
                                    </div>
                                    : null }
                                {self.footTraffic !== false ?
                                    <div className="retail-cpm-container">
                                        <Field
                                            validation="money"
                                            type="text"
                                            className="retail-cpm"
                                            placeholder="Retail CPM"
                                            value={!empty(instance.retailCPM) ? instance.retailCPM : ''}
                                            onChange={(e, value) => self.onChange(e, value, "retailCPM", key)}
                                        />
                                    </div>
                                    : null }

                            </div>
                        </div>
                    </Segment>
                    </div>


                );

            })}
            <Button
                onClick={self.addFlight}
                floated="right"
                icon="plus"
                className="add-flight-btn"
                content="Add a flight..."
            />
            </div>
        );
    }
}
export default FlightField;


// WEBPACK FOOTER //
// ./src/components/records/FlightField.js